import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBcy4CYUW-2U_Q6TPj6UR73eHf3QvL_gXk",
  authDomain: "mycv-d48b2.firebaseapp.com",
  projectId: "mycv-d48b2",
  storageBucket: "mycv-d48b2.appspot.com",
  messagingSenderId: "554222109482",
  appId: "1:554222109482:web:0938d9553e01658444d453",
  measurementId: "G-WVBQFESTD6"
};

export const FIREBASE_APP = initializeApp(firebaseConfig)
export const FIRESTORE_DB = getFirestore(FIREBASE_APP)
export const FIREBASE_STORAGE = getStorage(FIREBASE_APP)